export function addIdToGoogleAutocomplete(id) {
    let addIdToAddressAutocompleteInterval = setInterval(()=>{
        let pacContainer = document.getElementsByClassName('pac-container')[0];
        if (!!pacContainer) {
            pacContainer.id = id;
            clearInterval(addIdToAddressAutocompleteInterval);
        }
    }, 1000);
}